<template>
  <div class="drawer">
    <el-drawer
      size="1100px"
      title="添加服务"
      :visible.sync="drawerStatus"
      @close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="box">
        <div class="L">
          <div class="navbox">
            <div class="label">服务类型</div>
            <div class="value">
              <el-radio-group
                v-model="categoryCode"
                @change="changeCategoryCode"
              >
                <el-radio label="washing">洗澡</el-radio>
                <el-radio label="beauty">美容</el-radio>
                <el-radio label="spa">SPA</el-radio>
                <el-radio label="singleService">单项服务</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="serviceBox">
            <div
              v-for="serviceItem in serviceList"
              :key="serviceItem.serviceId"
            >
              <div class="label">
                {{ serviceItem.title }}
              </div>
              <div class="value">
                <div class="cageBox">
                  <div
                    class="cageItem"
                    :class="[isChecked(skuItem) ? 'active' : '']"
                    v-for="skuItem in serviceItem.serviceItems"
                    :key="skuItem.service_objectId"
                    @click="clickSku(serviceItem, skuItem)"
                  >
                    <div class="mask" v-if="!canUsed(skuItem)">
                      <div class="text">体重/毛发/品质不符</div>
                    </div>
                    <div class="cageName">
                      {{ skuItem.extend_attr }} {{ skuItem.service_objectName }}
                    </div>
                    <div class="cageName" style="font-size: 14px">
                      {{ skuItem.price }}/{{ skuItem.frequency_text }}
                    </div>
                    <!-- <img v-if="isChecked(skuItem)" class="checked" src="../../../../assets/img/bottomRightChecked.png">
										<img v-else class="checked" src="../../../../assets/img/bottomRightNoChecked.png"> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="R">
          <div class="label">已添加项目</div>
          <div class="value">
            <div class="tit">洗澡</div>
            <div class="val">
              <div
                v-for="item in selectedArr"
                :key="item.skuItem.service_objectId"
              >
                <el-tag
                  type="warning"
                  style="margin-bottom: 5px"
                  v-if="item.category_info.code === 'washing'"
                  closable
                  :disable-transitions="false"
                  @close="delService(item)"
                >
                  {{ item.title }} {{ item.skuItem.extend_attr }}
                  {{ item.skuItem.service_objectName }}
                  {{ item.skuItem.price }}元
                </el-tag>
              </div>
            </div>
            <div class="tit">美容</div>
            <div class="val">
              <div
                v-for="item in selectedArr"
                :key="item.skuItem.service_objectId"
              >
                <el-tag
                  type="warning"
                  style="margin-bottom: 5px"
                  v-if="item.category_info.code === 'beauty'"
                  closable
                  :disable-transitions="false"
                  @close="delService(item)"
                >
                  {{ item.title }} {{ item.skuItem.extend_attr }}
                  {{ item.skuItem.service_objectName }}
                  {{ item.skuItem.price }}元
                </el-tag>
              </div>
            </div>
            <div class="tit">SPA</div>
            <div class="val">
              <div
                v-for="item in selectedArr"
                :key="item.skuItem.service_objectId"
              >
                <el-tag
                  type="warning"
                  style="margin-bottom: 5px"
                  v-if="item.category_info.code === 'spa'"
                  closable
                  :disable-transitions="false"
                  @close="delService(item)"
                >
                  {{ item.title }} {{ item.skuItem.extend_attr }}
                  {{ item.skuItem.service_objectName }}
                  {{ item.skuItem.price }}元
                </el-tag>
              </div>
            </div>
            <div class="tit">单项服务</div>
            <div class="val">
              <div
                v-for="item in selectedArr"
                :key="item.skuItem.service_objectId"
              >
                <el-tag
                  type="warning"
                  style="margin-bottom: 5px"
                  v-if="item.category_info.code === 'singleService'"
                  closable
                  :disable-transitions="false"
                  @close="delService(item)"
                >
                  {{ item.title }} {{ item.skuItem.extend_attr }}
                  {{ item.skuItem.service_objectName }}
                  {{ item.skuItem.price }}元
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawerStatus: false,
      categoryCode: "washing",
      serviceList: [],
      selectedArr: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
  },
  props: {
    curPetItem: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getServiceList();
      console.log(this.curPetItem);
      if (!this.$public.isNull(this.curPetItem.tableData)) {
        this.selectedArr = this.curPetItem.tableData;
      }
    });
  },
  methods: {
    handleClose() {
		// closeOn
		if(this.selectedArr.length){
			let obj = JSON.stringify({ type: "close", list: this.selectedArr });
      this.$emit("submit", obj);
		}else{
			this.$emit("closeOn");
		}
      
    },
    clickSku(serviceItem, skuItem) {
      // console.log(serviceItem,skuItem)
      if (!this.canUsed(skuItem)) {
        this.$message({
          message: "体重/毛发/品质不符,不可选用！",
          type: "error",
        });
        return;
      }
      let obj = JSON.parse(JSON.stringify(serviceItem));
      obj.skuItem = skuItem;
      let index = -1;
      for (let i = 0; i < this.selectedArr.length; i++) {
        if (
          skuItem.service_objectId ===
          this.selectedArr[i].skuItem.service_objectId
        ) {
          index = i;
        }
      }
      if (index === -1) {
        obj.buyBack = serviceItem.buy_back;
        this.selectedArr.push(obj);
      } else {
        this.selectedArr.splice(index, 1);
      }
    },
    delService(item) {
      this.clickSku(item, item.skuItem);
    },
    changeCategoryCode() {
      this.getServiceList();
    },
    isChecked(skuItem) {
      for (let i = 0; i < this.selectedArr.length; i++) {
        if (
          this.selectedArr[i].skuItem.service_objectId ===
          skuItem.service_objectId
        ) {
          return true;
        }
      }
      return false;
    },
    // 获取洗美列表
    getServiceList() {
      let applytype = "0," + this.curPetItem.petItem.apply_type.value;
      let params = {
        keyword: "",
        applytype: applytype, // 应用分类 0:通用 1:猫 2:犬
        categoryId: "", // 分类编号
        categoryCode: this.categoryCode, // 分类编码washing(洗澡)beauty(美容)spa(SPA)foster(寄养)
        weight: -1, // 宠物体重
        pageIndex: 1,
        pageSize: 500,
      };
      let loading = this.$loading();
      this.$http
        .post("/api/Product/ProductLife/SimpleList", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            let serviceList = [];
            for (let i = 0; i < res.data.data.length; i++) {
              let serviceObj = res.data.data[i];
              for (let a = 0; a < serviceObj.serviceItems.length; a++) {
                let skuObj = serviceObj.serviceItems[a];
                let service_objectName = "";
                if (this.$public.isNull(skuObj.apply_features)) {
                  service_objectName += " ";
                } else {
                  if (
                    skuObj.apply_features.code === "" ||
                    skuObj.apply_features.code === "0"
                  ) {
                    service_objectName += " ";
                  } else {
                    service_objectName += skuObj.apply_features.name + " ";
                  }
                }
                if (this.$public.isNull(skuObj.apply_varieties)) {
                  service_objectName += " ";
                } else {
                  if (
                    skuObj.apply_varieties.code === "" ||
                    skuObj.apply_varieties.code === "0"
                  ) {
                    service_objectName += " ";
                  } else {
                    service_objectName += skuObj.apply_varieties.name + " ";
                  }
                }
                if (this.$public.isNull(skuObj.weight_detail)) {
                  service_objectName += " ";
                } else {
                  if (skuObj.weight_detail.enable_weight_limit !== 1) {
                    service_objectName += " ";
                  } else {
                    service_objectName +=
                      "(" +
                      skuObj.weight_detail.min_weight +
                      "-" +
                      skuObj.weight_detail.max_weight +
                      "kg)";
                  }
                }
                skuObj.service_objectName = service_objectName;
              }
              serviceList.push(serviceObj);
            }
            this.serviceList = serviceList;
          }
        });
    },
    canUsed(skuItem) {
      let isWeight = false,
        isSpecial = false,
        isHair = false;
      let cardSpecial = 50,
        cardHair = 50;
      if (
        skuItem.apply_varieties.code !== "0" &&
        skuItem.apply_varieties.code !== ""
      ) {
        cardSpecial = Number(skuItem.apply_varieties.code);
      }
      if (
        skuItem.apply_features.code !== "0" &&
        skuItem.apply_features.code !== ""
      ) {
        cardHair = Number(skuItem.apply_features.code);
      }
      if (
        this.$public.isNull(this.curPetItem.petItem.pet_varieties) ||
        cardSpecial >= Number(this.curPetItem.petItem.pet_varieties.value)
      ) {
        isSpecial = true;
      }
      if (
        this.$public.isNull(this.curPetItem.petItem.pet_features) ||
        cardHair >= Number(this.curPetItem.petItem.pet_features.value)
      ) {
        isHair = true;
      }
      if (skuItem.weight_detail.max_weight >= Number(this.curPetItem.weight)) {
        isWeight = true;
      }
      if (isWeight && isSpecial && isHair) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__header {
      margin-bottom: 10px;
    }
    .el-drawer__body {
      height: calc(100% - 75px);
    }
    .box {
      display: flex;
      padding: 12px 0;
      height: 100%;
      .L {
        width: 710px;
        height: 100%;
        box-sizing: border-box;
        padding: 76px 10px 0;
        border-right: 1px dashed;
        position: relative;
        .navbox {
          position: absolute;
          top: 0;
        }
        .serviceBox {
          height: 100%;
          overflow-y: auto;
          &::-webkit-scrollbar {
            width: 4px;
            // height: 4px;
          }
        }
        .label {
          font-size: 16px;
          color: #262626;
          padding: 16px 0;
          font-weight: bold;
          color: #262626;
        }
        .value {
          .cageBox {
            display: flex;
            flex-wrap: wrap;
            .cageItem {
              width: 166px;
              height: 74px;
              box-sizing: border-box;
              background-color: #fff;
              position: relative;
              padding: 15px 2px;
              text-align: center;
              line-height: 20px;
              cursor: pointer;
              margin: 0 0px 10px 5px;
              border: 1px solid #dddddd;
              border-radius: 4px;
              color: #999999;
              overflow: hidden;
              &.active {
                color: $mainColor;
                border-color: $mainColor;
              }
              .mask {
                position: absolute;
                background-color: rgba(0, 0, 0, 0.28);
                z-index: 1;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                .text {
                  font-size: 14px;
                  margin: auto;
                  display: inline-block;
                  color: #fff;
                  margin-top: 19px;
                  padding: 1px 5px;
                }
              }
              .cageName {
                font-size: 16px;
              }
              .checked {
                height: 18px;
                right: 0;
                bottom: 0;
                position: absolute;
              }
            }
          }
        }
      }
      .R {
        width: 378px;
        box-sizing: border-box;
        padding: 0 20px;
        .label {
          font-size: 16px;
          color: #262626;
          padding: 16px 0;
          font-weight: bold;
        }
        .value {
          .tit {
            font-size: 14px;
            color: #262626;
            padding: 16px 0 12px 0;
          }
          .val {
            border: 1px dashed #979797;
            padding: 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>
